import type { CloudAccountType } from '@repo/api-gw-sdk';

import { UpdateAccountRoleGcpInnerPanel } from './updateAccountRoleGcpInnerPanel';

export function RecreateAccountRoleGcpPanel(props: {
  accountType: CloudAccountType.Source | CloudAccountType.Restore;
  onUpdated: (success: boolean, sourceAccountId: string) => void;
  initialProjectId: string;
  onClose: () => void;
}) {
  return (
    <UpdateAccountRoleGcpInnerPanel
      headerTitle='Reinstall permissions'
      accountType={props.accountType}
      onUpdated={props.onUpdated}
      onClose={props.onClose}
      initialProjectId={props.initialProjectId}
    />
  );
}
